import { InspectionSheetDiagram } from '@editor/interfaces/inspection'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface DiagramState {
  /**
   * Plane diagrams for the inspection sheet.
   */
  diagrams: Record<string, InspectionSheetDiagram>
}

export const initialState: DiagramState = {
  diagrams: {},
}

export const diagramSlice = createSlice({
  name: 'diagram',
  initialState,
  reducers: {
    setDiagram: (state, action: PayloadAction<{ imageId: string; diagram: InspectionSheetDiagram }>) => {
      state.diagrams[action.payload.imageId] = action.payload.diagram
    },
    reset: () => initialState,
  },
})

export const { setDiagram, reset } = diagramSlice.actions

export default diagramSlice.reducer
